import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import DragAndDrop from 'shared/assets/svg/DragAndDrop.svg';

export const DragAndDropPlaceholder = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                height: '64px',
                width: '100%',
                padding: '16px',
                boxSizing: 'border-box',
                backgroundImage:
                    // eslint-disable-next-line max-len
                    "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='rgba(0, 0, 0, 0.30)' stroke-width='1' stroke-dasharray='8%2c 8' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e\")",
                borderRadius: '12px',
                typography: 'subtitle2',
                color: 'rgba(0, 0, 0, 0.30)',
            }}
        >
            <img
                src={String(DragAndDrop)}
                alt="drag-and-drop"
                style={{
                    marginRight: '12px',
                }}
            />
            {t('Drag and drop suppliers')}
        </Box>
    );
};
